<template>
  <div class="header-box" :class="{ 'fixed': isFixed }">
    <div class="header-first">
      <div class="header-part">
        <img class="logo" alt="LOGO" src="@/assets/pc/common/logo.png" @click="gotoHome">
        <div class="info">
          <div class="info-item">
            <a href="tel:29693116" @click="handlePhoneClick">
              <img class="info-icon" alt="phone" src="@/assets/pc/icons/phone.png">
              Call sales：2969-3116
            </a>
          </div>
          <div class="info-line"></div>
          <div class="info-item" @click="ContactClick">
            <img class="info-icon info-menu" alt="phone" src="@/assets/pc/icons/menu.png">
            Contact Us
          </div>
        </div>
      </div>
    </div>
    <div class="header-tab">
      <div class="header-part">
        <div class="nav">
          <el-menu class="el-menu-demo" mode="horizontal">
            <nav-menu :menuData="menu"></nav-menu>
          </el-menu>
        </div>
        <div class="search">
          <img class="search-icon" alt="search" src="@/assets/pc/icons/search.png">
          <input class="search-input" v-model="search" placeholder="Laptop Computers" autocomplete="off" @keyup.enter="toSearch">
          <div class="search-btn" @click="toSearch">Search</div>
        </div>
      </div>
    </div>
    <ContactUs :show="showContactUs" @close="closeContact"></ContactUs>
  </div>
</template>
<script>
import { $data } from '@/setting/data';
import NavMenu from './NavMenu.vue';
import ContactUs from "../common/ContactUs.vue";
export default {
  name: 'HeaderPC',
  components: {
    NavMenu,
    ContactUs
  },
  data() {
    return {
      isFixed: false,
      search: '',
      menu: $data.menu,
      showContactUs: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isFixed = window.scrollY > 80
    },
    handlePhoneClick() {
      this.$gioAction('navtopclick_hk', { 'jingtaititle_hk': 'Call sales' });
    },
    ContactClick() {
      this.showContactUs = true;
      this.$gioAction('navtopclick_hk', { 'jingtaititle_hk': 'Contact Us' });
    },
    closeContact() {
      this.showContactUs = false;
    },
    toSearch() {
      if (this.search) {
        this.$gioAction('navtopclick_hk', { 'jingtaititle_hk': 'Search' });
        this.$gioAction('searchSuccess', { 'jingtaititle_hk': this.search });
        let url = window.location.href;
        let path = url.includes('?') ? `/search?key=${this.search}&${url.split('?')[1]}` : `/search?key=${this.search}`;
        const routeData = this.$router.resolve({
          path: path
        });
        window.open(routeData.href);
      }
    },
    gotoHome() {
      this.$gioAction('navtopclick_hk', { 'jingtaititle_hk': 'Home' });
      let url = window.location.href;
      let path = '/';
      if (url.includes('?')) {
          const queryString = url.split('?')[1];
          const params = queryString.split('&');
          const filteredParams = params.filter(param => !param.startsWith('key='));
          if (filteredParams.length > 0) {
              path = `/?${filteredParams.join('&')}`;
          }
      }
      const routeData = this.$router.resolve({
        path: path
      });
      window.open(routeData.href);
    }
  }
}
</script>
<style scoped lang="scss">
.header-box {
  width: 100%;
  background: #fff;
  color: #333;

  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .header-part {
    max-width: 1170px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @include pc-style-note {
      max-width: 940px;
    }
  }

  .header-first {
    height: 30px;
    background-color: #F4F6F8;
    font-size: 14px;
    border-bottom: 1px solid #ededed;

    @include pc-style-note {
      font-size: 12px;
    }
  }

  .logo {
    width: 140px;
    height: auto;
    cursor: pointer;
  }

  .info {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .info-item,
    .info-item a {
      display: flex;
      align-items: center;
      cursor: pointer;
      text-decoration: none;
      color: #333333;
    }

    .info-line {
      width: 1px;
      height: 17px;
      margin: 0 20px;
      background: #E1E1E1;
    }

    .info-icon {
      width: 15px;
      height: auto;
      margin-right: 4px;

      &.info-menu {
        width: 12px;
      }
    }
  }

  .header-tab {
    height: 54px;
    background-color: #ffffff;
    font-size: 16px;

    @include pc-style-note {
      font-size: 14px;
    }
  }

  .nav {
    height: 100%;

    .el-menu-demo {
      border-width: 0;
      height: 100%;
    }
  }

  .search {
    position: relative;
    display: flex;
    justify-content: flex-end;
    align-self: center;

    .search-icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 10px;
      width: 14px;
      height: auto;
    }

    .search-input {
      display: block;
      box-sizing: border-box;
      width: 250px;
      height: 34px;
      padding-left: 33px;
      padding-right: 10px;
      border: 1px solid #E1E1E1;
      border-right: 0;
      color: #333;
      border-radius: 0;
      font-size: 14px;

      @include pc-style-note {
        font-size: 12px;
      }

      &::placeholder {
        color: #999;
      }

      &:focus {
        outline: none;
        border-color: #0076CE;
      }
    }

    .search-btn {
      width: 80px;
      height: 34px;
      text-align: center;
      line-height: 34px;
      color: #fff;
      background-color: #0076CE;
      cursor: pointer;
    }
  }
}
</style>